import React from 'react';
import { FormControl, FormGroup, InputGroup } from 'react-bootstrap';
import { I18n } from 'react-redux-i18n';

const MarkupJobs = ({ markup, onChange }) => (
  <div className="network-setting-section">
    <h3 className="section-title">{
      I18n.t('networkSetting.MarkupJobs')}</h3>
    <div className="markup-input-group">
      <div className="input-field-wrapper">
        <div className="input-label-row">
          <span className="input-label">
            {I18n.t('networkSetting.MarkupJobsDes')}
          </span>
        </div>
        <FormGroup className="qup-input-group mb-0">
          <InputGroup className="single-addon-right">
            <FormControl
              type="number"
              className="form-custom"
              value={markup}
              onChange={onChange}
              placeholder="0"
              min={0}
              max={100}
            />
            <InputGroup.Append>
              <InputGroup.Text>%</InputGroup.Text>
            </InputGroup.Append>
          </InputGroup>
        </FormGroup>
      </div>
    </div>
  </div>
);

export default MarkupJobs;